import { FieldValidation } from '@rjsf/utils';

export const gitlabRepoLocationValidation = (
  value: string,
  validation: FieldValidation,
) => {
  try {
    if (!value) {
      validation.addError('Invalid repository location provided.');
    }
  } catch {
    validation.addError('Unable to parse the Repository Location');
  }
};
